// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhh_ji","CommentListPlaceholder--Legacy":"ih_b bhh_ra bhh_wo"};